import { render, staticRenderFns } from "./myClient.vue?vue&type=template&id=2e7b737c"
import script from "./myClient.vue?vue&type=script&lang=js"
export * from "./myClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports